enum ZipAvailabilityProbabilityEnum {
	highInStock = 'HIGH_IN_STOCK',
	mediumInStock = 'MEDIUM_IN_STOCK',
	lowInStock = 'LOW_IN_STOCK',
	outOfStock = 'OUT_OF_STOCK',
	notInRange = 'NOT_IN_RANGE',
	notSoldTemp = 'NOT_SOLD_TEMP'
}

export default ZipAvailabilityProbabilityEnum;
